export { default } from './CurrencyInput';



// WEBPACK FOOTER //
// ./src/design-system/atoms/CurrencyInput/index.jsx